<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
    <q-card>
      <q-card-main>
        <div class="row">
          <div class="col-sm-8 col-xs-6">
            <g-input
              id="refCodigo"
              name="refCodigo"
              ref="refCodigo"
              tipo="text"
              etiqueta="Código"
              validacao="numeric"
              :desabilitar="true"
              :foco="false"
              v-model="paginaStatus.assunto.codAssunto"
            >
            </g-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xs-12">
            <g-input
              id="refDescricao"
              name="refDescricao"
              ref="refDescricao"
              tipo="text"
              etiqueta="Descrição"
              validacao="required | maxlength(100)"
              :tamanho="100"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="paginaStatus.assunto.desAssunto"
            >
            </g-input>
          </div>
        </div>

        <div class="row">

          <div class="col-xs-5 col-md-5">
            <g-option
              id="ativo"
              name="ativo"
              ref="refAtivo"
              tipo="radio"
              :option="arrayAtivoEnum"
              :desabilitar="paginaStatus.desabilitarEdicao"
              etiqueta="Ativo"
              validacao="required"
              v-model="indAtivo"
            ></g-option>
          </div>
        </div>
        <div class="row">

          <div class="col-xs-5 col-md-5">
            <g-option
              id="toogleVisivelPortal"
              name="toogleVisivelPortal"
              ref="toogleVisivelPortal"
              tipo="radio"
              :option="arrayAtivoEnum"
              :desabilitar="paginaStatus.desabilitarEdicao"
              etiqueta="Visível no portal de serviços."
              validacao="required"
              v-model="indVisivelPortal"
            ></g-option>
          </div>
        </div>
      </q-card-main>
    </q-card>
    <div class="col-12 text-right pad-20t-h10-80b">
      <q-btn
        round
        id="salvar"
        name="salvar"
        class="fixed"
        color="positive"
        icon="check"
        size="lg"
        @click="salvar"
        style="right: 18px; bottom:18px"
        v-show="!paginaStatus.desabilitarEdicao"
      >
        <q-tooltip>Salvar</q-tooltip>
      </q-btn>
    </div>
  </div>
</template>

<script>

import api from 'components/util/api'
import msg from 'components/util/msg'
import util from 'components/util/util'
import utilHttp from 'components/util/utilHttp'
import GInput from 'components/util/gInput'
import GSelect from 'components/util/gSelect'
import GDatepicker from 'components/util/gDatepicker'
import GOption from 'components/util/gOption'
import GBreadcrumb from 'components/util/gBreadcrumb'
import constante from 'components/util/constante'

export default {
  data () {
    return {
      chaveLocalStorage: 'assunto',
      indVisivelPortal: '',
      arrayAtivoEnum: constante.ATIVO_ENUM,
      indAtivo: '',
      paginaStatus: {
        assunto: {
          codAssunto: '',
          desAssunto: ''
        },
        caminhoMigalha: [
          {
            icone: '',
            descricao: '',
            rotaNome: ''
          }
        ]
      }
    }
  },
  methods: {
    salvar () {
      var self = this
      if (util.validarComponentes(this.$refs)) {
        self.paginaStatus.assunto.codUsuario = this.$login.getCodUsuario()
        if (self.paginaStatus.operacao.descricao === 'Novo') {
          utilHttp.httpPostCarregando(api.ASSUNTO, self.paginaStatus.assunto, resposta => {
            if (resposta.status === 201) {
              util.exibirToastSucesso(msg.m(2))
              util.retornarCaminhoMigalhaPaginaAnterior(this)
            } else {
              util.exibirToastFalha('Erro ao salvar Assunto')
            }
          })
        } else if (self.paginaStatus.operacao.descricao === 'Editar Assunto Geral') {
          var filtro = '/'.concat(self.paginaStatus.assunto.codAssunto)
          utilHttp.httpPutCarregando(api.ASSUNTO.concat(filtro), self.paginaStatus.assunto, resposta => {
            if (resposta.status === 200) {
              util.exibirToastSucesso(msg.m(3))
              util.retornarCaminhoMigalhaPaginaAnterior(this)
            }
          })
        }
      }
    }
  },
  watch: {
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)
      },
      deep: true
    },
    indVisivelPortal: {
      handler (valor) {
        if (valor) {
          this.paginaStatus.assunto.indVisivelPortal = this.indVisivelPortal
        }
      },
      deep: true
    },
    indAtivo: {
      handler (valor) {
        if (valor) {
          this.paginaStatus.assunto.indAtivo = this.indAtivo
        }
      },
      deep: true
    }
  },
  mounted () {
    if (this.$route.params.paginaStatus) {
      this.paginaStatus = this.$route.params.paginaStatus
      this.paginaStatus.caminhoMigalha.push({
        icone: this.paginaStatus.operacao.icone,
        descricao: this.paginaStatus.operacao.descricao,
        rotaNome: 'assunto'
      })
    } else if (util.recuperarDoStorage(this.chaveLocalStorage)) {
      this.paginaStatus = util.recuperarDoStorage(this.chaveLocalStorage)
    }
    if (this.paginaStatus.operacao.descricao !== 'Novo') {
      this.indVisivelPortal = this.paginaStatus.assunto.indVisivelPortal
      this.indAtivo = this.paginaStatus.assunto.indAtivo
    } else {
      this.indVisivelPortal = 'S'
      this.indAtivo = 'S'
    }
  },

  components: { GBreadcrumb, GInput, GSelect, GDatepicker, GOption }

}
</script>
